import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import TextInput from "components/forms/inputs/text";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faKey } from "components/icon-library";
import { showError, showSuccess } from "lib/notification";
import { useForm } from "react-hook-form";
import { adminDoPatchProfile } from "services/admin/profile";
import * as yup from "yup";

const PasswordForm = () => {
  const schema = yup
    .object({
      oldPassword: yup.string().validateRequired(),
      newPassword: yup
        .string()
        .validatePassword()
        .notOneOf([yup.ref("oldPassword")], "validate_password_same_as_old")
        .validateRequired(),
      newPasswordAgain: yup
        .string()
        // TODO: not yetp possible using custom yupValidator
        .oneOf([yup.ref("newPassword")], "validate_password_do_not_match")
        .validateRequired(),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { oldPassword: "", newPassword: "", newPasswordAgain: "" },
  });

  const onSubmit = async (values: any) => {
    try {
      const { oldPassword, newPassword, newPasswordAgain } = values;
      await adminDoPatchProfile({ oldPassword, newPassword, newPasswordAgain });
      showSuccess("Salasana vaihdettu.");
    } catch (err) {
      showError("Salasanan vaihto epäonnistui.");
    }
  };

  const buttons: FormButtonInterface[] = [
    {
      ...SubmitButton,
      text: "Vaihda salasana",
      align: "left",
      postIcon: faKey,
    },
  ];

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Grid>
        <Row>
          <Col>
            <TextInput
              password
              name="oldPassword"
              label="Nykyinen salasana"
              required
            />
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col>
            <TextInput
              password
              name="newPassword"
              label="Uusi salasana"
              required
            />
          </Col>
          <Col>
            <TextInput
              password
              name="newPasswordAgain"
              label="Uusi salasana toistamiseen"
              required
            />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default PasswordForm;
